import {remCalc} from '../../_utils'

const getStyles = (props: {
    labelPosition: string
    textWidth: string
    textSize: string
    iconSize: string
    width: string
    justifyContent: string
}) => {
    return {
        container: {
            display: 'inline-flex',
            alignItems: props.labelPosition === 'top' ? 'center' : 'start',
            gap: props.textWidth === 'small' ? remCalc(4) : remCalc(6),
            flexDirection: props.labelPosition === 'top' ? 'row' : 'column',
            justifyContent: props.justifyContent ? props.justifyContent : 'unset',
            width: props.width ? props.width : 'auto',
        },
        description: {
            width: (() => {
                switch (props.textWidth) {
                    case 'big':
                        return remCalc(130)
                    case 'medium':
                        return remCalc(110)
                    case 'small':
                        return remCalc(90)
                    default:
                        return 'auto'
                }
            })(),
            textStyle: props.textSize === 'big' ? 'body-small' : 'body-xsmall',
            color: 'foreground.neutral.default',
            fontWeight: 'normal',
            lineHeight: 'normal',
        },
        labelIcon: {
            display: 'flex',
            width: props.width ? props.width : props.iconSize === 'big' ? remCalc(67) : remCalc(42),
            height: props.iconSize === 'big' ? remCalc(33) : remCalc(22),
            justifyContent: 'center',
            alignItems: 'center',
            bg: 'transparent',
            p: 0,
            minWidth: 'auto',
        },
        icon: {
            width: props.width ? props.width : props.iconSize === 'big' ? remCalc(67) : remCalc(42),
            height: props.iconSize === 'big' ? remCalc(33) : remCalc(22),
        },
        energyLabelContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(12),
        },
        energyLabelText: {
            display: 'inline-flex',
            height: remCalc(28),
            paddingY: remCalc(4),
            justifyContent: 'center',
            alignItems: 'center',
            color: 'foreground.neutral.muted',
            textStyle: 'body-xsmall',
        },
    }
}

export default {
    baseStyle: getStyles,
}
